module.exports = __webpack_public_path__ + "static/media/SMT-Series-Roof-Top.7fc1db90.png";